import { MESSAGE_STATUS } from 'react-easyrocket';
import { TransactionStatus } from '../types';

export const withdrawalStatusMap: Record<
  TransactionStatus,
  { key: string; status: MESSAGE_STATUS } | null
> = {
  success: { key: 'messagesWithdraw.success', status: MESSAGE_STATUS.SUCCESS },
  return: { key: 'messagesWithdraw.return', status: MESSAGE_STATUS.INFO },
  failure: { key: 'messagesWithdraw.failer', status: MESSAGE_STATUS.ERROR },
  cancel: { key: 'messagesWithdraw.cancel', status: MESSAGE_STATUS.ERROR }
};

export const depositStatusMap: Record<
  Exclude<TransactionStatus, 'cancel'>,
  { key: string; status: MESSAGE_STATUS } | null
> = {
  success: { key: 'messagesDeposit.success', status: MESSAGE_STATUS.SUCCESS },
  return: { key: 'messagesDeposit.return', status: MESSAGE_STATUS.INFO },
  failure: { key: 'messagesDeposit.failer', status: MESSAGE_STATUS.ERROR }
};
